import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TopupService {
  private topupState = new BehaviorSubject<boolean>(false); // Default state: closed
  topupState$ = this.topupState.asObservable();

  constructor() {}

  openPopup() {
    this.topupState.next(true); // Open popup
  }

  closePopup() {
    this.topupState.next(false); // Close popup
  }
}
